export interface AditivoModelo {
  id: string;
  titulo: string;
  texto: string;
}



const aditivosPorModelo: Record<string, AditivoModelo> = {
  aditivo1: {
    id: "aditivo1",
    titulo:
      "Modelo Aditivo 1 - Quando a proteção de dados for tratada como ANEXO - Cliente DPO Seusdados CONTROLADOR",
    texto: `
Posição: Cliente DPO SEUSDADOS COMO CONTROLADOR

INSTRUÇÃO ESPECÍFICA: Este modelo de aditivo deverá ser utilizado como "capa" do instrumento ANEXO de proteção de dados.

Modelo de aditivo para contratos vigentes – Relação Controlador-Controlador / Co-Controladores

ADITIVO AO CONTRATO DE [XXXXX]

Pelo presente Aditivo ao Contrato de [xxxxx] celebrado em [xx/xx/xxxx] entre

A. [empresa], [qualificação], neste ato representada nos termos dos seus atos constitutivos, doravante referida(o) simplesmente como “EMPRESA XPTO”;

e, do outro lado,

B. [empresa], [qualificação], neste ato representada nos termos dos seus atos constitutivos, doravante referida(o) simplesmente como “Empresa ABCD”;

As partes qualificadas acima são doravante designadas, em conjunto, “Partes”, ou, individualmente, “Parte”:

CONSIDERAÇÕES INICIAIS, que devem orientar a interpretação deste instrumento:

CONSIDERANDO QUE a EMPRESA XPTO e a Empresa ABCD assinaram Contrato de [xxxxx] em [xx/xx/xxxx], tendo como escopo [xxxxx];

CONSIDERANDO QUE a EMPRESA XPTO e a Empresa ABCD exercerão, em conjunto, o tratamento de informações pessoais envolvendo [xxxxx];

CONSIDERANDO QUE a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados - LGPD) está em vigor desde setembro de 2020;

CONSIDERANDO QUE a LGPD criou a Autoridade Nacional de Proteção de Dados (ANPD), com funções regulatórias e sancionatórias, dispondo de poder de fiscalização de agosto de 2021 em diante, estando as PARTES sujeitas a fiscalização sobre a conformidade de suas atividades com a referida lei a qualquer tempo;

ACORDO DE VONTADES firmado livremente entre as partes:

Resolvem as Partes celebrar o presente Aditivo nos seguintes termos:

1. O presente aditamento traz como parte integrante indissociável desse instrumento, o ANEXO DE PROTEÇÃO DE DADOS, que tem como escopo regular os processos de tratamentos de dados desenvolvidos no âmbito deste contrato pelas PARTES, garantindo a sua conformidade com a Lei 13.789 de agosto de 2018.

2. O ANEXO DE PROTEÇÃO DE DADOS, a partir dessa data, por meio de suas cláusulas, passa a fazer parte integral do Contrato e aditamentos anteriormente celebrados, mantendo-se vigentes e eficazes todas as pactuações anteriores a esta, prevalecendo, em caso de eventual conflito, o disposto neste aditamento.

3. Desse modo, tratando-se de acordo de vontades celebrado entre empresas, na lógica de interpretação contratual própria dos contratos empresariais, as partes firmam o presente aditamento, com a ciência das duas testemunhas abaixo indicadas.

4. As Partes reconhecem as assinaturas digitais e eletrônicas, em todas as suas categorias, como válidas e suficientes para manifestar as suas vontades, bem como para assumir as obrigações e responsabilidades sob este Contrato, comprometendo-se a não contestar a sua validade ou eficácia em juízo. Por esta razão, dispensam a assinatura deste Contrato em via física.

Local, ____ de _________ de 20___

_________________________________        ____________________________
EMPRESA XPTO                             Empresa ABCD
Rep. Legal:                              Rep. Legal

Testemunha (1)                           Testemunha (2)
_________________________________         ____________________________
Nome [ xxx ]                             Nome [ xxx ]
RG [ xxx ]                               RG [ xxx ]
CPF [ xxx ]                              CPF [ xxx ]
    `,
  },

  aditivo2: {
    id: "aditivo2",
    titulo:
      "Modelo Aditivo 2 - Quando a proteção de dados for tratada como ANEXO - Cliente DPO Seusdados CONTROLADOR",
    texto: `
Posição: Cliente DPO SEUSDADOS COMO CONTROLADOR

INSTRUÇÃO ESPECÍFICA: Este modelo de aditivo deverá ser utilizado como "capa" do instrumento ANEXO de proteção de dados.

Modelo de aditivo para contratos vigentes – Relação Controlador-Controlador / Co-Controladores

ADITIVO AO CONTRATO DE [XXXXX]

Pelo presente Aditivo ao Contrato de [xxxxx] celebrado em [xx/xx/xxxx] entre

A. [empresa], [qualificação], neste ato representada nos termos dos seus atos constitutivos, doravante referida(o) simplesmente como “EMPRESA XPTO”;

e, do outro lado,

B. [empresa], [qualificação], neste ato representada nos termos dos seus atos constitutivos, doravante referida(o) simplesmente como “Empresa ABCD”;

As partes qualificadas acima são doravante designadas, em conjunto, “Partes”, ou, individualmente, “Parte”:

CONSIDERAÇÕES INICIAIS, que devem orientar a interpretação deste instrumento:

CONSIDERANDO QUE a EMPRESA XPTO e a Empresa ABCD assinaram Contrato de [xxxxx] em [xx/xx/xxxx], tendo como escopo [xxxxx];

CONSIDERANDO QUE a EMPRESA XPTO e a Empresa ABCD exercerão, em conjunto, o tratamento de informações pessoais envolvendo [xxxxx];

CONSIDERANDO QUE a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados - LGPD) está em vigor desde setembro de 2020;

CONSIDERANDO QUE a LGPD criou a Autoridade Nacional de Proteção de Dados (ANPD), com funções regulatórias e sancionatórias, dispondo de poder de fiscalização de agosto de 2021 em diante, estando as PARTES sujeitas a fiscalização sobre a conformidade de suas atividades com a referida lei a qualquer tempo;

ACORDO DE VONTADES firmado livremente entre as partes:

Resolvem as Partes celebrar o presente Aditivo nos seguintes termos:

1. O presente aditamento traz como parte integrante indissociável desse instrumento, o ANEXO DE PROTEÇÃO DE DADOS, que tem como escopo regular os processos de tratamentos de dados desenvolvidos no âmbito deste contrato pelas PARTES, garantindo a sua conformidade com a Lei 13.789 de agosto de 2018.

2. O ANEXO DE PROTEÇÃO DE DADOS, a partir dessa data, por meio de suas cláusulas, passa a fazer parte integral do Contrato e aditamentos anteriormente celebrados, mantendo-se vigentes e eficazes todas as pactuações anteriores a esta, prevalecendo, em caso de eventual conflito, o disposto neste aditamento.

3. Desse modo, tratando-se de acordo de vontades celebrado entre empresas, na lógica de interpretação contratual própria dos contratos empresariais, as partes firmam o presente aditamento, com a ciência das duas testemunhas abaixo indicadas.

4. As Partes reconhecem as assinaturas digitais e eletrônicas, em todas as suas categorias, como válidas e suficientes para manifestar as suas vontades, bem como para assumir as obrigações e responsabilidades sob este Contrato, comprometendo-se a não contestar a sua validade ou eficácia em juízo. Por esta razão, dispensam a assinatura deste Contrato em via física.

Local, ____ de _________ de 20___

_________________________________        ____________________________
EMPRESA XPTO                             Empresa ABCD
Rep. Legal:                              Rep. Legal

Testemunha (1)                           Testemunha (2)
_________________________________         ____________________________
Nome [ xxx ]                             Nome [ xxx ]
RG [ xxx ]                               RG [ xxx ]
CPF [ xxx ]                              CPF [ xxx ]
    `,
  },
};

export default aditivosPorModelo;